import { ReactNode } from 'react';
import style from './Header.module.scss';

export interface HeaderProps {
  children?: ReactNode;
}

const Header = ({ children }: HeaderProps) => {
  return <div className={style.header}>{children}</div>;
};

export default Header;
